import { Routes } from '@angular/router';
import { authGuard } from './guard/auth.guard';
import { VendorStepGuard } from './guard/vendor-step.guard';
import { HomeStepGuard } from './guard/home-step.guard';



export const routes: Routes = [
    { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
    {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule),
    },
    {
        path: 'vendor',
        loadChildren: () => import('./pages/vendor/vendor.module').then(m => m.VendorModule),
        canActivate: [VendorStepGuard],
    },
    {
        path: 'homecare',
        loadChildren: () => import('./homecare/home-care/homecare.module').then(m => m.HomeCareModule),
        canActivate: [HomeStepGuard]
    }
];